import React ,{useEffect}from 'react'
import { Button, Modal, Box, TextField,Typography,Backdrop,CircularProgress} from '@mui/material'
import { handleMucjCableUpdate } from './MucjCableUpdateModal.util';
const MucjCableUpdateModal = ({ mucjLoader,setMucjLoader,openModal,url2,handleCloseUpdateModal,updateFields,setUpdateFields,params,setOpenModal,setMUCJTableData,viewjobid,setLoading,setSelectedMUCJRows,setAlertOpen,setSnackMsg,setSuccessAlertOpen,setSuccessSnackMsg}) => {
   
    const [errors, setErrors] = React.useState({})
   
    const handleUpdateFieldChange = (e) => {
        const { id, value } = e.target;
        setUpdateFields((prevData) => ({
            ...prevData,
            [id]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [id]: '' 
        }));
    }
      const validateFields = () => {
        const newErrors = {};

        if (!updateFields.cable_id) {
            newErrors.cable_id = 'Cable ID should not be empty';
        }
    
        if (!updateFields.cable_weight || isNaN(updateFields.cable_weight)) {
            newErrors.cable_weight = 'Weight is required to be a valid number';
        } 
    
        if (!updateFields.cable_length || !/^\d+$/.test(updateFields.cable_length)) {
            newErrors.cable_length = 'Length must be an integer.';
        }
    
        if (!updateFields.cable_gauge || !/^\d+$/.test(updateFields.cable_gauge)) {
            newErrors.cable_gauge = 'Cable Gauge must be an integer.';
        }
        return newErrors;
    };
    const handleSubmit =async (e) => {
        e.preventDefault();
     const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setOpenModal(false);
        await handleMucjCableUpdate(setMucjLoader,updateFields, url2,setAlertOpen,setSnackMsg,setSuccessAlertOpen,setSuccessSnackMsg, params, setOpenModal,setMUCJTableData,viewjobid,setLoading,setSelectedMUCJRows);
        resetFormData();
        }
      // Function to reset form data
  const resetFormData = () => {
    setErrors({});
};
    useEffect(() => {
        if (!openModal) {
            setErrors({});
        }
    }, [openModal, setUpdateFields]);
    return (
        <div>
            <Modal
                open={openModal}
                onClose={handleCloseUpdateModal}
            >
                <Box sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            pt: 2,
            pb: 3,
            pl: 3,
            pr: 3,
            borderRadius: 2,
          }}>
                    <Typography variant="h6" sx={{ pb: 1 }}>Update Cable Details</Typography>
                    <TextField
                        size='small'
                        label="Cable ID"
                        id="cable_id"
                        value={updateFields.cable_id}
                        onChange={handleUpdateFieldChange}
                        sx={{ width: "100%" }}
                        error={!!errors.cable_id}
                        helperText={errors.cable_id}
                    />
                    <TextField
                        size='small'
                        margin="normal"
                         label="Weight(Tonnes)"
                        id="cable_weight"
                        value={updateFields.cable_weight}
                        onChange={handleUpdateFieldChange}
                        sx={{ width: "100%" }}
                        error={!!errors.cable_weight}
                        helperText={errors.cable_weight}
                        type='number'
                    />
                    <TextField
                        size='small'
                        margin="normal"
                        label="Length(m)"
                        id="cable_length"
                        value={updateFields.cable_length}
                        onChange={handleUpdateFieldChange}
                        sx={{ width: "100%" }}
                        error={!!errors.cable_length}
                        helperText={errors.cable_length}
                        type='number'
                    />
                    <TextField
                        size='small'
                        margin="normal"
                        label="Cable Gauge"
                        id="cable_gauge"
                        value={updateFields.cable_gauge}
                        onChange={handleUpdateFieldChange}
                        sx={{ width: "100%" }}
                        error={!!errors.cable_gauge}
                        helperText={errors.cable_gauge}
                        type='number'
                    />
                    <Box sx={{ display: 'flex',justifyContent:'flex-end',mt: 2 }}>
                        <Button id='mucj-update-cancel-button'style={{ color: "white", backgroundColor: "#142032", fontSize: "12", height: "30px",marginRight: "10px" }} onClick={handleCloseUpdateModal} >CANCEL</Button>
                        <Button id="mucj-update-submit-button" variant="contained"onClick={handleSubmit} style={{ color: "white", backgroundColor: "#142032", fontSize: "12", height: "30px" }}>SUBMIT</Button>

                    </Box>
                </Box>
            </Modal>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={mucjLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </div>
    )
}

export default MucjCableUpdateModal